import { useNavigate } from 'react-router-dom';
import type { Video } from '../lib/types';
import { Thumb } from './Thumb';

export function VideoCard({ video, showViews = true }: { video: Video; showViews?: boolean }): JSX.Element {
  const nav = useNavigate();
  const meta = showViews ? `${video.views}回視聴 · ${daysAgo(video.publishedAt)}` : daysAgo(video.publishedAt);

  return (
    <div onClick={() => nav(`/videos/${video.videoId}`)} style={{ cursor: 'pointer' }}>
      <Thumb video={video} />
      <div style={{ padding: '10px 2px 0' }}>
        <div style={{ fontSize: 13.5, fontWeight: 700, lineHeight: 1.5, marginBottom: 5 }}>{video.title}</div>
        <div style={{ fontSize: 11.5, color: 'var(--ink-soft)', lineHeight: 1.6 }}>
          {video.channelName} · {video.presenter}
        </div>
        <div style={{ fontSize: 11.5, color: 'var(--ink-quiet)' }}>{meta}</div>
      </div>
    </div>
  );
}

function daysAgo(iso: string): string {
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (diff <= 0) return '今日';
  if (diff === 1) return '昨日';
  if (diff < 7) return `${diff}日前`;
  if (diff < 30) return `${Math.floor(diff / 7)}週間前`;
  return `${Math.floor(diff / 30)}か月前`;
}
